<template>
  <div>
    <section
      class="add_new_head white--body tx--bege relative cover m_bg_blue"
      style="background-image:url('assets/img/layout/bg_serg.jpg');"
    >
      <div class="popup_close close-animate">
        <a @click="goBackRoute"><CloseSvg /></a>
      </div>
      <a class="no_mobile link_goback" @click="goBackRoute">
        חזרה <ArrowBack />
      </a>
      <div class="inner_width flex flex--column center">
        <h1 class="title">
          <span class="bold">יצירת ניתוח לשיבוץ -</span>{{ activeDoctor.name }}
        </h1>
        <div class="add_step_all flex flex--content--center no_mobile">
          <div class="add_step active">1</div>
          <div class="add_step">2</div>
          <div class="add_step">3</div>
          <div class="add_step">4</div>
        </div>
      </div>
    </section>
    <section class="add_new_main">
      <div class="add_st1" style="display:block">
        <div class="subtitle center">
          ליצירת ניתוח אנא הזינו תעודת זהות
        </div>
        <validation-observer ref="createAppForm">
          <form
            @submit.prevent="sendForm"
            v-promise-btn="{ action: 'submit' }"
            autocomplete="off"
          >
            <div class="w-570">
              <div class="form_input input-38">
                <label>ת.ז*</label>
                <validation-provider
                  :rules="{ required: true, israeliId: [isDarcon] }"
                  name="passport"
                  v-slot="{ errors }"
                >
                  <input
                    name="passport"
                    v-model="passport"
                    v-mask="isDarcon ? 'X'.repeat(100) : ['####', '#########']"
                    type="tel"
                    autocomplete="off"
                  />
                  <span class="error-message" v-if="errors.length > 0">
                    {{ errors[0] }}
                  </span>
                </validation-provider>
              </div>

              <div class="add_new_row flex desk-flex">
                <div class="form_check form_check-black">
                  <label>
                    <input type="checkbox" v-model="isDarcon" />
                    דרכון
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>

              <div
                class="form_submit center "
                :class="{ bt_disable: notValid }"
              >
                <button type="submit" class="bt_blue">הבא</button>
              </div>
            </div>
          </form>
        </validation-observer>
      </div>
    </section>
  </div>
</template>

<script>
import CloseSvg from "../../../assets/img/svg/close.svg";
import ArrowBack from "../../../assets/img/svg/arrow_r.svg";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Error from "@/components/Popups/Error";
import { getHash } from "../../../utilities/hash.js";

export default {
  name: "AddNewSurgery",
  data() {
    return {
      isDarcon: false,
      doctorName: "",
      passport: "",
    };
  },
  mounted() {
    // Cache
    const isReload = localStorage.getItem("cache-surg2");
    if (!isReload) {
      window.location.reload();
      localStorage.setItem("cache-surg2", true);
    }

    let doc = this.doctors.find((d) => d.id == this.activeDoctor);
    if (typeof doc != "undefined") {
      this.doctorName = doc.name;
    }
  },
  computed: {
    ...mapGetters(["activeDoctor", "doctors"]),
    notValid() {
      if (!this.passport) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapMutations(["SET_PASSPORT"]),
    ...mapActions(["SET_SURGERY_PATIENT"]),
    sendForm() {
      return new Promise((resolve, reject) => {
        this.$refs.createAppForm.validate().then((res) => {
          if (res) {
            this.$API
              .validatePassport(this.passport)
              .then((res) => {
                const passport_type = this.isDarcon ? "foreign" : "israeli";
                if (res.status == "ERROR") {
                  this.SET_SURGERY_PATIENT({
                    apotropos: "",
                    parental_status: "",
                    birth_date: "",
                    first_name: "",
                    gender: "",
                    id_num: this.passport,
                    last_name: "",
                    phone: "",
                    second_phone: "",
                    status: "",
                    email: "",
                    passport_type,
                  });
                } else {
                  this.SET_SURGERY_PATIENT({ ...res, passport_type });
                }
                // this.SET_PASSPORT(res.id_num);

                resolve();
                this.$API.scheduleTempSurgery({
                  doctor_id: this.activeDoctor?.id,
                  passport: this.passport,
                  passport_type,
                });
                this.$router.push({ name: "surg-add-info" });
              })
              .catch((e) => {
                this.$modal.show(Error, {
                  title: e?.message || "",
                });
                reject();
              });
          } else {
            resolve();
          }
        });
      });
    },
    goBackRoute() {
      const isMobile = window.innerWidth < 1200;
      if (isMobile) {
        this.$router.go(-1);
        return;
      }
      const hashData = JSON.parse(localStorage.getItem("hashData"));
      if (!hashData || !Object.keys(hashData).length) {
        return this.$router.push("/dashboard/surgeries");
      }
      const hash = getHash({});
      return this.$router.push("/dashboard/surgeries#" + hash);
    },
  },
  watch: {
    isDarcon() {
      this.passport = "";
    },
  },
  components: {
    CloseSvg,
    ArrowBack,
  },
};
</script>
